import React from 'react';

import { Typography } from '@mui/material';

import { Nullable } from '@clearverify/types';

import { Modal } from 'src/components/common';
import { InvitePeoPayrollProviderStaffByCVStaffModalForm } from 'src/components/peoPayrollProviderStaff';
import { ModalId } from 'src/constants/modals';
import { usePeoPayrollProviderById } from 'src/hooks/peoPayrollProvider';
import { useModal } from 'src/hooks/shared';

import { PeoPayrollProviderStaffInviteModalArgs } from '../types';

type InvitePeoPayrollProviderStaffByCVStaffModalProps = {
  peoPayrollProviderId: Nullable<string>;
};

export const InvitePeoPayrollProviderStaffByCVStaffModal: React.FC<
  InvitePeoPayrollProviderStaffByCVStaffModalProps
> = ({ peoPayrollProviderId }) => {
  const { isOpen, closeModal, switchClosability, args } =
    useModal<PeoPayrollProviderStaffInviteModalArgs>(ModalId.PeoPayrollProviderInviteStaffModal);

  const { isPartnership } = usePeoPayrollProviderById(args?.peoPayrollProviderId);

  const onCloseModal = React.useCallback(() => {
    closeModal();
  }, [closeModal]);

  const entityName = isPartnership ? 'Partnership' : 'PEO Payroll Provider';

  return (
    <Modal
      title={`Invite ${entityName} Staff`}
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      headerPadding="32px 32px 4px"
      headerProps={{
        sx: {
          lineHeight: '28px',
        },
      }}
      contentProps={{
        sx: {
          pt: 0,
        },
      }}
    >
      <Typography variant="body1" color="text.secondary" mb="24px">
        Invite {entityName} Staff by using their email address
      </Typography>
      <InvitePeoPayrollProviderStaffByCVStaffModalForm
        peoPayrollProviderId={peoPayrollProviderId}
        onCloseModal={onCloseModal}
        switchClosability={switchClosability}
      />
    </Modal>
  );
};
